export const CLMI_APPLY_TRANSLATIONS = 'x-clmi-applytranslations';
